import { useTranslation } from '@/hooks/useTranslation';
import { toCurrency } from '@/utilities/formatting';
import { useTheme } from '@simplywallst/ui-core';

interface PriceChartMinMaxProps {
  top: number;
  max: number;
  min: number;
  bottom: number;
  currencyISO: string;
}

const PriceChartMinMax = ({
  top,
  max,
  min,
  bottom,
  currencyISO,
}: PriceChartMinMaxProps) => {
  const theme = useTheme();
  const t = useTranslation();
  return (
    <>
      <g transform={`translate(0, ${top})`}>
        <text
          fontSize="12"
          textAnchor="start"
          alignmentBaseline="hanging"
          fill={theme.color.white}
        >
          {t('app.component.priceChart.max', {
            currency: toCurrency(max, 2, currencyISO),
          })}
        </text>
      </g>

      <g transform={`translate(0, ${bottom})`}>
        <text
          fontSize="12"
          textAnchor="start"
          alignmentBaseline="baseline"
          fill={theme.color.white}
        >
          {t('app.component.priceChart.min', {
            currency: toCurrency(min, 2, currencyISO),
          })}
        </text>
      </g>
    </>
  );
};

export default PriceChartMinMax;
